/**
 * Avatar — het package-component met één correctie erop.
 *
 * ⚠️ DIT IS GEEN EIGEN COMPONENT EN GEEN FORK. Het rendert `Avatar` uit
 * `@bcs-bv/design-system` en plakt er één klasse bij die de initialen verticaal
 * recht zet; alle props gaan ongewijzigd door. Zodra het DS-team de
 * `line-height` upstream corrigeert, kan deze map weg en gaat de export in de
 * barrel terug naar het package — één regel, geen migratie.
 *
 * WAAROM EEN OMHULSEL EN GEEN CSS-OVERRIDE ERGENS ANDERS. De klassennamen van het
 * package zijn gehasht (`bcs-Avatar-module__avatar__3xMuZ`). Een selector daarop
 * werkt vandaag en breekt stil bij de volgende package-build: geen foutmelding,
 * geen rode test, alleen een bolletje dat weer scheef staat. Het component
 * accepteert `className`, dus die weg is er niet nodig.
 *
 * WAAROM IN DE BARREL EN NIET PER GEBRUIKSPLEK. Er zijn er vandaag vier. Zet je
 * de klasse daar neer, dan is de vijfde — die iemand volgende maand schrijft —
 * weer scheef, en niets zegt er iets over. De barrel verbergt de bron al; dit
 * hoort daar.
 */
import type { AvatarProps } from '@bcs-bv/design-system';
import { Avatar as PackageAvatar } from '@bcs-bv/design-system';

import styles from './Avatar.module.css';

export function Avatar({ className, ...props }: AvatarProps) {
  return (
    <PackageAvatar
      {...props}
      className={className === undefined ? styles.alignInitials : `${styles.alignInitials} ${className}`}
    />
  );
}
